// @ts-expect-error moduleResolution:nodenext issue 54523
import { html, css, nothing } from 'lit';
// @ts-expect-error moduleResolution:nodenext issue 54523
import { customElement, state } from 'lit/decorators.js';
import LightElement from './light-element.js';

@customElement('product-comparison-table')
export default class ProductComparisonTable extends LightElement {

	@state()
	productIds: string[] = [];

	// TODO: Duplication station just to get thumbnails. Don't do this for production
	@state()
	products: any[] = [];

	@state()
	showComparisonBar: boolean = false;

	@state()
	comparingMode: boolean;

	@state()
	isComparisonBarHidden: boolean = false;

	connectedCallback() {
		super.connectedCallback();
		this.loadProductIds();
	}

	private loadProductIds() {

		const urlParams = new URLSearchParams(window.location.search);
		const urlProductIds = urlParams.get('ids');
		if (urlProductIds) {
			this.productIds = urlProductIds.split(',').filter(id => id.trim() !== '');
			localStorage.setItem('productComparisonIds', JSON.stringify(this.productIds));
			return;
		}

		const comparisonKey = 'productComparisonIds';
		const storedIds = JSON.parse(localStorage.getItem(comparisonKey) || '[]');
		this.productIds = Array.isArray(storedIds) ? storedIds : [];
	}

	render() {

		return html`
			<product-comparison .productIds=${this.productIds}></product-comparison>
		`
	}
}
